import { Checkbox, Tooltip } from 'antd';
import FormField from 'components/FormField';
import { set, uniq } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { FV, Validate } from './share';
import { DisabledProps } from '../TaskForm/share';

export const validate: Validate = (errors, values, t) => {
  const { autoReviewConfig: { contents = [] } = {} } = values;

  if (contents.length === 0) {
    set(errors, 'autoReviewConfig.contents', t('aide.请选择评价内容'));
  }
};

export interface AutoReviewContentsFieldProps {
  platform: General.PlatformUpperCase;
}

function AutoReviewContentsField(props: AutoReviewContentsFieldProps & DisabledProps) {
  const { platform, disabled } = props;

  const { t } = useTranslate();

  return (
    <FormField<Required<FV>['autoReviewConfig']['contents']>
      required
      name="autoReviewConfig.contents"
      label={t('review.评价内容')}
    >
      {({ field: { value, onChange, onBlur } }) => {
        const isChecked = (type: Marketing.ReviewReplyType) => value.includes(type);

        const onCheckedChange = (checked: boolean, type: Marketing.ReviewReplyType) => {
          onBlur();

          onChange(checked ? uniq([...value, type]) : value.filter((item) => item !== type));
        };

        const emptyDisabled = platform === 'LAZADA';

        const empty = (
          <Checkbox
            disabled={emptyDisabled || disabled}
            checked={isChecked('EMPTY')}
            onChange={({ target: { checked } }) => onCheckedChange(checked, 'EMPTY')}
          >
            {t('review.无内容')}
          </Checkbox>
        );

        return (
          <div>
            <Checkbox
              disabled={disabled}
              checked={isChecked('ANY')}
              onChange={({ target: { checked } }) => onCheckedChange(checked, 'ANY')}
            >
              {t('review.带文字/图像/视频')}
            </Checkbox>
            {emptyDisabled ? (
              <Tooltip title={t('aide.Lazada对无内容的评价，暂不支持自动回评')}>{empty}</Tooltip>
            ) : (
              empty
            )}
          </div>
        );
      }}
    </FormField>
  );
}

export default AutoReviewContentsField;
